import { __awaiter, __generator, __read, __spread } from "tslib";
import { Fetch } from '@ekuaibao/fetch';
function getCorporationset() {
    return Fetch.GET('/api/v2/corporationset/watermark', {});
}
export var defaultInvalidSuffixes = ['exe', 'com', 'sys', 'dll', 'bat', 'py', 'sh'];
var attachmentSetting;
export var fnParseTemplateFields = function (template) {
    return template.map(function (field) {
        if (field.type === 'attachments') {
            field.toolTip = parseAttachmentTipText('BILL', field);
        }
        return field;
    });
};
export var fetchAttachmentConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!!attachmentSetting) return [3, 2];
                return [4, getCorporationset()];
            case 1:
                attachmentSetting = (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.attachmentSetting;
                if (!attachmentSetting) {
                    attachmentSetting = {};
                }
                _c.label = 2;
            case 2: return [2, attachmentSetting];
        }
    });
}); };
export var parseAttachmentTipText = function (suffixesPath, field) {
    var _a, _b;
    if (!attachmentSetting) {
        return undefined;
    }
    var nameOrType = (field === null || field === void 0 ? void 0 : field.name) || (field === null || field === void 0 ? void 0 : field.type);
    var _c = attachmentSetting.onFields, onFields = _c === void 0 ? [] : _c, _d = attachmentSetting.onPath, onPath = _d === void 0 ? [] : _d;
    var defaultInvalidSuffixeString = i18n.get("\u4E0D\u652F\u6301{__k0}\u683C\u5F0F\u7684\u6587\u4EF6", {
        __k0: defaultInvalidSuffixes.map(function (item) { return '.' + item; }).join('、')
    });
    if (onFields.includes(nameOrType) || onPath.includes(suffixesPath)) {
        var suffixs_1 = [];
        var sizes_1 = [];
        (_a = attachmentSetting === null || attachmentSetting === void 0 ? void 0 : attachmentSetting.fileType) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a;
            (_a = item.name) === null || _a === void 0 ? void 0 : _a.forEach(function (suffix) {
                suffixs_1.push(suffix);
                sizes_1.push(item.size);
            });
        });
        var minLimitSize = Math.min.apply(Math, __spread(sizes_1)) || 60;
        var validAccept = ((_b = suffixs_1 === null || suffixs_1 === void 0 ? void 0 : suffixs_1.map(function (item) { return '.' + item; })) === null || _b === void 0 ? void 0 : _b.join(',')) || 'xxx';
        var validAcceptText = validAccept === null || validAccept === void 0 ? void 0 : validAccept.replace('.', '');
        return validAccept
            ? i18n.get("\u53EA\u5141\u8BB8\u4E0A\u4F20{__k0}\uFF0C{__k1}M\u4EE5\u5185\u7684\u6587\u4EF6", {
                __k0: validAcceptText,
                __k1: minLimitSize
            })
            : defaultInvalidSuffixeString;
    }
    return defaultInvalidSuffixeString;
};
